import yup from '@/libs/yup';

const getValidationSchema = (isEdit: boolean) =>
    yup.object({
        idn: yup.string().idn().required(),
        title: yup.string().required(),
        version: yup.string(),
        description: yup.string(),
        readme: yup.string(),
        is_auto_update_enabled: yup.boolean().required(),
        registry_idn: yup.string().idn().required('Registry is required'),
        registry_item_idn: isEdit
            ? yup.string().nullable().required('Module is required')
            : yup.string().nullable(),
        registry_item_version: yup.string().nullable().version()
    });
export default getValidationSchema;
